<template>
  <div>
    <v-app>
      <v-main>
        <router-view />
      </v-main>
    </v-app>
  </div>
</template>
<script>
export default {
  name: 'App',

  data: () => ({}),
  computed: {},
  watch: {},
  created() {},
  methods: {}
}
</script>
